import React from "react";
import SegmentPage from "../components/aa/SegmentPage";
import { REST_TRANSLATIONS, REST_IMAGES } from "../data/restaurants";

export default function RestaurantsPage() {
  return <SegmentPage translations={REST_TRANSLATIONS} images={REST_IMAGES} />;
}
